import { render, staticRenderFns } from "./modal-init-appendix.vue?vue&type=template&id=6c4892ce&scoped=true"
import script from "./modal-init-appendix.vue?vue&type=script&lang=js"
export * from "./modal-init-appendix.vue?vue&type=script&lang=js"
import style0 from "./modal-init-appendix.vue?vue&type=style&index=0&id=6c4892ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4892ce",
  null
  
)

export default component.exports